import React from "react"
import _omit from "lodash/omit"
import { useBuilderState } from "app/forms/builder/builder-context"
import {
  useEditingContext,
  useElement,
  useUnsavedChanges
} from "app/forms/data/form-data"
import { useStyles } from "app/forms/data/use-styles"
import { Element } from "./element"
import { determineGroup } from "../utils/determine-group"

/**
 * TODO:
 * Most of what createElement does can be simplified moved into `Element` now that
 * we have hooks. Leaving here to limit change in a large refactor.
 */
export const createElement = (Component, options = {}) => {
  const ElementComponent = props => {
    const { setUnsavedChanges } = useUnsavedChanges()
    const { type, ...defaultComponentProps } = options
    const { defaults, group, onClick, ...componentProps } = props
    const name = props.name || options.name || Component.displayName
    const groupName = determineGroup(props) || group || name
    const [element, update] = useElement(name, {
      ...defaults,
      group: groupName,
      type,
      props: _omit(componentProps, ["props"])
    })
    const styles = useStyles()
    const editing = useEditingContext()
    const builderState = useBuilderState()
    const updater = attributes => {
      setUnsavedChanges(true)
      update({ name, ...attributes })
    }
    const activate = event => {
      if (!editing && onClick) {
        onClick(event)
      }
      builderState.setActiveElement(name)
    }
    return (
      <Element
        element={element}
        defaults={defaults}
        onChange={updater}
        onClick={activate}
      >
        <Component
          defaults={defaults}
          editing={editing}
          style={styles.forElement(groupName)}
          {..._omit(defaultComponentProps, ["props"])}
          {..._omit(element, ["props"])}
          {..._omit(componentProps, ["props"])}
        />
      </Element>
    )
  }

  ElementComponent.displayName = `Element(${Component.name})`
  ElementComponent.componentType = Component.componentType
  return ElementComponent
}
